import { Box, CircularProgress, Typography } from '@mui/material';
import React from 'react';

type LoadingOverlayProps = {
    loading: boolean;
};

export default function LoadingOverlay({ loading }: LoadingOverlayProps) {
    if (!loading) return null;

    return (
        <Box
            key="loading-overlay"
            sx={{
                position: 'fixed',
                top: '97px', // 跳過 header 的高度
                left: 0,
                width: '100vw',
                height: 'calc(100vh - 97px)', // 扣掉 header 的高度
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                zIndex: 12,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <CircularProgress
                size={300}
                sx={{
                    color: '#E5673E',
                }}
            />
            <Typography
                sx={{
                    marginTop: '1rem',
                    fontSize: '1.5rem',
                    fontWeight: 600,
                    fontFamily: 'Poppins',
                }}
            >
                Loading your content
            </Typography>
        </Box>
    );
}
